export const filterObjFn = (data = [], val, targets = []) => {
  const needle = val.toLowerCase();

  let filtered = data;

  for (const target of targets) {
    filtered = filtered.filter(v => v[target].toLowerCase().indexOf(needle) > -1);
  }

  return filtered;
};
